import type { Account } from "./account";

export const StrategyName = {
	Session: "session",
} as const;

export type StrategyName = (typeof StrategyName)[keyof typeof StrategyName];

export const LB_STRATEGIES = Object.freeze(
	Object.values(StrategyName),
) as readonly StrategyName[];

export function isLbStrategy(value: string): value is StrategyName {
	return LB_STRATEGIES.includes(value as StrategyName);
}

/**
 * Interface for strategy-specific database operations
 * Allows strategies to interact with the database without direct SQL access
 */
export interface StrategyStore {
	/**
	 * Reset session for an account
	 * Updates session_start and session_request_count
	 */
	resetAccountSession(
		accountId: string,
		timestamp: number,
	): void | Promise<void>;

	/**
	 * Get all accounts (optional method for strategies that need full account list)
	 */
	getAllAccounts?(): Promise<Account[]>;

	/**
	 * Update account request count
	 */
	updateAccountRequestCount?(
		accountId: string,
		count: number,
	): void | Promise<void>;

	/**
	 * Get account by ID
	 */
	getAccount?(accountId: string): Promise<Account | null>;

	/**
	 * Get available (not paused, not rate-limited) accounts for a provider,
	 * optionally filtered to a routing group.
	 */
	getAvailableAccountsByProvider(
		provider: Account["provider"],
		groupId?: string | null,
	): Promise<Account[]>;

	/**
	 * Count the rotation roster for a provider (excluding accounts that await
	 * a re-login), optionally scoped to a routing group.
	 */
	countAccountsByProvider(
		provider: Account["provider"],
		groupId?: string | null,
	): Promise<number>;
}
